import styled from 'styled-components/native';

import { coral, neutralDark, white } from '../../../../constants/color';
import Image from '../../../../elements/Image';
import Touchable from '../../../../elements/Touchable';

const IMAGE_HEIGHT = 66;
const PADDING = 2;
const ORIGIN_PRICE_MARGIN_TOP = 2;
const ORIGIN_PRICE_LINE_HEIGHT = 13;

const CURRENT_PRICE_MARGIN_TOP = 1;
const CURRENT_PRICE_LINE_HEIGHT = 15;
const CURRENT_PRICE_MARGIN_BOTTOM = 2;

export const OnSaleItemHeight = (fontScale: number) =>
  PADDING +
  IMAGE_HEIGHT +
  ORIGIN_PRICE_MARGIN_TOP +
  ORIGIN_PRICE_LINE_HEIGHT * fontScale +
  CURRENT_PRICE_MARGIN_TOP +
  CURRENT_PRICE_LINE_HEIGHT * fontScale +
  CURRENT_PRICE_MARGIN_BOTTOM +
  PADDING;

export default {
  Touchable: styled(Touchable)`
    /* PADDING_TOP from NewArrivals styles */
    margin: 6px 4px 0 0;
  `,
  Container: styled.View`
    background-color: ${white};
    border-radius: 3px;
    padding: ${PADDING}px;
    align-items: center;
  `,
  Image: styled(Image)`
    width: ${IMAGE_HEIGHT}px;
    height: ${IMAGE_HEIGHT}px;
    border-radius: 3px;
  `,
  OriginalPrice: styled.Text`
    color: ${neutralDark};
    margin-top: ${ORIGIN_PRICE_MARGIN_TOP}px;
    font-size: 11px;
    line-height: ${ORIGIN_PRICE_LINE_HEIGHT}px;
    text-align: center;
    text-decoration-line: line-through;
  `,
  DiscountIcon: styled(Image)`
    width: 12px;
    height: 12px;
  `,
  CurrentPriceWrapper: styled.View`
    flex-direction: row;
    align-items: center;
  `,
  CurrentPrice: styled.Text`
    color: ${coral};
    margin: ${CURRENT_PRICE_MARGIN_TOP}px 0 ${CURRENT_PRICE_MARGIN_BOTTOM}px 4px;
    font-size: 13px;
    font-weight: 600;
    line-height: ${CURRENT_PRICE_LINE_HEIGHT}px;
  `,
};
